// extracted by mini-css-extract-plugin
export default {"rolesModalContent":"style_rolesModalContent__xzYuX","rolesModalTitle":"style_rolesModalTitle__TpO4A","rolesList":"style_rolesList__dSHMt","roleItem":"style_roleItem__eCGQY"};